// extracted by mini-css-extract-plugin
export var headerCell = "_3t-1";
export var loadingSpinnerContainer = "_3t-4";
export var rowWrapper = "_3t-3";
export var standaloneTable = "_3t-5";
export var table = "_3t-0";
export var white = "_3t-2";